export const produtDetailConfig = {
  color: {
    border: "#cccccc",
  },
};
